import { Avatar } from "@chakra-ui/avatar";
import { Box, Text } from "@chakra-ui/layout";

const UserListItem = ({ user, handleFunction }) => {
  return (
    <Box
      onClick={handleFunction}
      cursor="pointer"
      bg="#F6E8C6"
      border="1px solid transparent"
      transition="all 0.16s ease"
      _hover={{
        background: "#8D414B",
        color: "#FBF0D9",
        transform: "translateY(-1px)",
        boxShadow: "0 8px 20px -10px rgba(141, 65, 75, 0.55)",
      }}
      w="100%"
      d="flex"
      alignItems="center"
      color="#243D27"
      px={3}
      py={2.5}
      mb={2}
      borderRadius="14px"
    >
      <Avatar mr={3} size="sm" name={user.name} src={user.pic} />
      <Box minW={0}>
        <Text fontWeight={500} isTruncated>
          {user.name}
        </Text>
        <Text fontSize="xs" opacity={0.75} isTruncated>
          {user.email}
        </Text>
      </Box>
    </Box>
  );
};

export default UserListItem;
